/* eslint-disable */
// Support component names relative to this directory:
var vehicleProductRequireContext = require.context('vehicle_product', true);
var sharedComponentsRequireContext = require.context('components', true);

var ReactRailsUJS = require('react_ujs');
ReactRailsUJS.useContexts([
  vehicleProductRequireContext,
  sharedComponentsRequireContext,
]);
